<template>
  <div v-if="show" class="fixed-mobile" style="display: none">
    <div class="fixed-mobile__top">
      <form
        id="my-form"
        ref="myMessageForm"
        v-if="showForm"
        @submit.prevent="submit"
      >
        <div class="dorm-form-tab">
          <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
            <svg
              viewBox="0 0 20 20"
              class="icon"
              style="font-size: 30px; color: rgb(235, 96, 129);"
            >
              <use xlink:href="/icon/icons.svg#icon-fiyat-sor"></use>
            </svg>
            <div class="dorm-form-tab__title">REZERVASYON</div>
          </div>
        </div>
        <div class="clear" @click="$emit('close')">
          <span class="close" ref="close">&times;</span>
        </div>
        <v-input ref="myInput" placeholder="Ad Soyad" v-model="user.name" />
        <label for="password" v-if="emptyName" class="myValidationText"
          >Bu kısım boş geçilemez!</label
        >
        <div class="datetime-picker-wrapper">
          <FunctionalCalendar
            :key="key"
            v-model="reservation_date"
            :is-modal="true"
            :is-date-range="true"
            :is-separately="true"
            :is-multiple="true"
            placeholder="Tarih Seçiniz"
            date-format="yyyy-mm-dd"
            :limits="limits"
            :marked-dates="markedDates"
            :enabled-dates="availableDays"
            :disabled-dates="['beforeToday']"
            :day-names="names.day"
            :month-names="names.month"
          ></FunctionalCalendar>
        </div>
        <VueInputRestricted placeholder="Telefon No" v-model="user.phone" />
        <label for="phone" v-if="emptyPhone" class="myValidationText"
          >Bu kısım boş geçilemez!</label
        >
        <label for="phone" v-if="falsePhone" class="myValidationText"
          >Telefon numarası 0 ile başlamalıdır!</label
        >
        <label for="phone" v-if="shortPhone" class="myValidationText"
          >Telefon numarası 11 hane olmalıdır!</label
        >
        <v-input
          type="text"
          placeholder="E-Posta Adresi"
          v-model="user.email"
        />
        <label for="email" v-if="falseEmail" class="myValidationText"
          >Geçersiz e-posta formatı!</label
        >
        <label for="email" v-if="emptyEmail" class="myValidationText"
          >Bu kısım boş geçilemez!</label
        >
        <v-input type="number" placeholder="Kişi Sayısı" v-model="user.adult" />
        <div class="dorm-form-price">
          <div class="dorm-form-price__title">Toplam Ücret</div>
          <div class="dorm-form-price__price" v-if="prices.total !== 0">
            {{ prices.total }} TL
            <small>{{ prices.night }} gece {{ prices.day }} gün</small>
          </div>
          <div v-else>
            <div class="text-muted">Fiyat almak için tarih seçiniz</div>
          </div>
        </div>
      </form>

      <button
        class="button gray icon-left fw dorm-form__button"
        v-if="!isNumberShow && !showForm && !showSuccessMessage"
        @click="showNumber"
      >
        <span class="button__wrp">
          <span class="button__icon">
            <svg class="icon">
              <use xlink:href="/icon/icons.svg#icon-headphone"></use>
            </svg>
          </span>
          <span class="button__txt">YURDU ARA</span>
        </span>
      </button>

      <button
        v-if="isNumberShow && !showForm && !showSuccessMessage"
        class="button gray icon-left fw dorm-form__button"
      >
        <a :href="'tel:' + callPhone"
          ><span class="button__wrp">
            <span class="button__icon">
              <svg class="icon">
                <use xlink:href="/icon/icons.svg#icon-headphone"></use>
              </svg>
            </span>
            <span class="button__txt">{{ callPhone }}</span>
          </span>
        </a>
      </button>

      <button
        class="button green icon-left fw dorm-form__button"
        @click="$emit('send-whatsapp')"
        v-if="!showForm && !showSuccessMessage"
      >
        <span class="button__wrp">
          <span class="button__icon">
            <svg class="icon">
              <use xlink:href="/icon/icons.svg#icon-whatsapp"></use>
            </svg>
          </span>
          <span class="button__txt">YURDA YAZ</span>
        </span>
      </button>
    </div>
    <div class="fixed-mobile__bottom">
      <button
        class="button red fw dorm-form__submit"
        v-if="!showForm && !showSuccessMessage"
        @click="$emit('toggle')"
      >
        <span class="button__wrp"
          ><span class="button__txt">
            REZERVASYON
          </span></span
        >
      </button>
      <button
        class="button red fw dorm-form__submit"
        v-if="showForm && !showSuccessMessage"
        @click="submit"
      >
        <span class="button__wrp"
          ><span class="button__txt">
            REZERVE ET
          </span></span
        >
      </button>
    </div>

    <Modal2 :active="apiOk" @onModalClose="closeApiOk">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">MESAJINIZ GÖNDERİLDİ!</h2>
          <div class="">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span>
            </p>
            <p>
              <span class="mycolorBlue"
                >Arkadaşlarımız en yakın zamanda sizinle iletişime
                geçecek.</span
              >
            </p>
          </div>
        </div>
      </div>
    </Modal2>

    <Modal2 :active="apiError.show" @onModalClose="closeApiError">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">Hata!</h2>
          <div class="">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue"
                >Rezervasyon gerçekleştirilirken bir sorun oluştu.</span
              >
            </p>
            <br />
            <p>
              <span class=" text-muted">{{
                apiError.message || 'Bilinmeyen bir hata'
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </Modal2>
  </div>
</template>

<script>
import Modal2 from '@/components/Modal2'
import VueInputRestricted from '@/components/VueInputRestricted'
import axios from 'axios'
import { FunctionalCalendar } from 'vue-functional-calendar'
import { mapGetters } from 'vuex'

export default {
  components: {
    FunctionalCalendar,
    VueInputRestricted,
    Modal2
  },
  props: {
    show: Boolean,
    showSuccessMessage: Boolean,
    showForm: Boolean,
    dates: Array,
    callPhone: String,
    room: Object
  },
  data() {
    return {
      key: 0,
      isNumberShow: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      apiOk: false,
      reservation_date: null,
      apiError: {
        show: false,
        message: null
      },
      user: {
        adult: 1,
        name: '',
        email: '',
        phone: ''
      },
      names: {
        day: ['Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts', 'Pzr'],
        month: [
          'Ocak',
          'Şubat',
          'Mart',
          'Nisan',
          'Mayıs',
          'Haziran',
          'Temmuz',
          'Ağustos',
          'Eylül',
          'Ekim',
          'Kasım',
          'Aralık'
        ]
      },
      limits: {
        min: this.toString(new Date()),
        max: this.toString(
          new Date(new Date().setDate(new Date().getDate() + 850))
        )
      }
    }
  },
  methods: {
    loaded() {
      this.key++
    },
    closeApiOk() {
      this.apiOk = false
    },
    showApiOk() {
      this.apiOk = true
      this.$emit('toggle')
    },
    closeApiError() {
      this.apiError.show = false
    },
    showApiError(msg) {
      this.apiError.show = true
      this.apiError.message = msg
    },
    fixDate(date) {
      let datetime = new Date(date)
      let fixedDate = `${datetime.getFullYear()}-`
      if (datetime.getMonth() + 1 < 10) {
        fixedDate += '0' + (datetime.getMonth() + 1) + '-'
      } else {
        fixedDate += datetime.getMonth() + 1 + '-'
      }
      if (datetime.getDate() < 10) {
        fixedDate += '0' + datetime.getDate()
      } else {
        fixedDate += datetime.getDate()
      }
      return fixedDate
    },
    fixDates(start, end) {
      return {
        start: this.fixDate(start),
        end: this.fixDate(end)
      }
    },
    showNumber() {
      this.isNumberShow = true
    },
    calculatePriceAndDays(startDate, endDate, dailyPrice, adult) {
      const start = new Date(startDate)
      const end = new Date(endDate)
      const millisecondsPerDay = 24 * 60 * 60 * 1000
      const totalDays = Math.round(Math.abs((end - start) / millisecondsPerDay))
      return {
        day: totalDays - 1,
        total: totalDays * dailyPrice * adult,
        night: totalDays
      }
    },
    submit() {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      let email = this.user.email
      const verifiedMail = this.$helpers.validateEmail(email)

      if (!this.user.email) {
        this.emptyEmail = true
      } else if (this.user.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.user.name) {
        this.emptyName = true
      }
      if (!this.user.phone) {
        this.emptyPhone = true
      }

      if (this.user.phone && !this.user.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (
        this.user.phone &&
        !this.falsePhone &&
        this.user.phone.length !== 11
      ) {
        this.shortPhone = true
      }

      if (
        !this.emptyName &&
        !this.emptyEmail &&
        !this.falseEmail &&
        verifiedMail &&
        !this.emptyPhone &&
        !this.falsePhone &&
        !this.shortPhone
      ) {
        let self = this
        this.messageEnabled = false
        const dates = this.fixDates(
          this.reservation_date.dateRange.start,
          this.reservation_date.dateRange.end
        )
        axios
          .post(`/site/room/reservation`, {
            name: this.user.name,
            email: this.user.email,
            phone: this.user.phone,
            room_id: this.room.id,
            start_date: dates.start,
            end_date: dates.end,
            capacity: this.user.adult
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showApiOk()
            } else {
              this.showApiError(response.data.message)
            }
          })
          .catch(error => {
            if (error.response) {
              this.showApiError(error.response.data.message)
            }
          })
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'first_name',
      'last_name',
      'mail1',
      'phone',
      'university_name',
      'faculty_name',
      'university_id',
      'faculty_id'
    ]),
    availableDays() {
      return this.dates.filter(d => !!d.data).map(d => d.str)
    },
    markedDates() {
      const res = this.dates
        .filter(d => !!d.data)
        .map(d => ({
          date: d.str,
          class: +d.remainingCapacity === 0 ? 'full-reserved' : 'available'
        }))
      this.loaded()
      return res
    },
    prices() {
      if (this.user.adult < 0) return { total: 0 }
      if (!this.room) return { total: 0 }
      let startDate = null
      let endDate = null
      if (this.reservation_date !== null) {
        startDate = this.reservation_date.dateRange.start
        endDate = this.reservation_date.dateRange.end
      }
      if (!startDate || !endDate) {
        return { total: 0 }
      }
      return this.calculatePriceAndDays(
        startDate,
        endDate,
        this.room.daily_price,
        this.user.adult
      )
    }
  },
  created() {
    this.user.name = this.first_name + ' ' + this.last_name
    this.user.email = this.mail1
    this.user.phone = this.phone
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/components/dorm-form';
.datetime-picker-wrapper {
  border-bottom: 1px solid #dadce2;
  padding-bottom: 3px;
  .vfc-multiple-input {
    border: none;
    display: flex;
    input {
      border: none;
      width: unset;
      &:first-child {
        border-right: 1px solid #dadce2;
      }
    }
  }
  .vfc-main-container.vfc-modal {
    width: 95%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
